export enum ViagemItemsEnum {
	VIAGENS = "VIAGENS",
	PEDIDOS = "PEDIDOS",
	DIARIAEMBARQUES = "DIARIAEMBARQUES",
	ON_TIME = "ON_TIME",
	PRESTACAOSERVICO = "PRESTACAOSERVICO",
	DIVERGENCIASSAT = "DIVERGENCIASSAT",
	LOGISTICATRAFEGO = "LOGISTICATRAFEGO",
}

export enum GestaoItemsEnum {
	GESTAOPESSOAS = "GESTAOPESSOAS",
	USUARIOS = "USUARIOS",
	GESTAOVEICULOS = "GESTAOVEICULOS",
	CHECKLIST = "CHECKLIST",
	USOCOMUM = "USOCOMUM",
}

export enum RastreamentoItemsEnum {
	ROTAS = "ROTAS",
	RASTREAMENTO = "RASTREAMENTO",
}

export enum DashboardItemsEnum {
	DASHBOARD = "DASHBOARD",
	INDICADORES = "INDICADORES",
}

export enum FinanceiroItemsEnum {
	PRECIFICACAO = "PRECIFICACAO",
	COTACAO = "COTACAO",
	FATURAMENTO = "FATURAMENTO",
}

export enum DiariasItemsEnum {
	DIARIAS = "DIARIAS",
}

export enum ConfigItemsEnum {
	CONFIG = "CONFIG",
}

export enum UserItemsEnum {
	USER = "USER",
}

export enum NavbarItemsEnum {
	VIAGEMEPEDIDOS = "VIAGEMEPEDIDOS",
	GESTAOITEMS = "GESTAOITEMS",
	RASTREAMENTO = "RASTREAMENTO",
	DASHBOARD = "DASHBOARD",
	FINANCEIRO = "FINANCEIRO",
	DIARIAS = "DIARIAS",
	DASHBOARDMOBILE = "DASHBOARDMOBILE",
}

export enum NavbarRightItemsEnum {
	CONFIG = "CONFIG",
	USER = "USER",
}
